const gradeList = ['tk', 'k', '1', '2', '3', '4', '5', '6', '6m', '7', '8'];

export function sanitizeGradeShortCode(gradeShortCode?: string) {
    return gradeList.includes(gradeShortCode || '') ? gradeShortCode : '4';
}
